import type { ArticleHighlight as ArticleHighlightBlok } from "@/generated/sb";
import { ArticleHighlight as ArticleHighlightUI } from "@repo/ui-parkmobile/ArticleHighlight";

import { articleResolver } from "@/lib/storyblok/adaptors";
import { storyblokEditable } from "@storyblok/react";
import { trackCtaClick } from "@/utils/trackingScripts";

const ArticleHighlight = ({ blok }: { blok: ArticleHighlightBlok }) => {
  const items = blok.items
    ?.map((item) => {
      const relatedArticle =
        typeof item.relatedArticle === "string" ? null : item.relatedArticle;

      if (!relatedArticle) return null;

      const articleData = articleResolver({
        article: {
          ...relatedArticle,
          buttons: item.buttons,
        } as any,
      });

      if (!articleData) return null;

      const sectionName = articleData.title;
      const contentDescription = articleData.description?.children || "";

      return {
        ...articleData,
        title: {
          content: articleData.title,
        },
        buttons: articleData.buttons?.map((button) => ({
          ...button,
          onClick: () => {
            const originalOnClick = button.onClick;
            trackCtaClick({
              event: "ctaClick",
              section: sectionName,
              ctaText: button.text || "",
              config: "button",
              contentDescription,
              link: button.href || "",
            });
            originalOnClick?.();
          },
        })),
      };
    })
    .filter(Boolean);

  return (
    <ArticleHighlightUI
      backgroundColor={blok.backgroundColor}
      topPadding={blok.topPadding}
      bottomPadding={blok.bottomPadding}
      layout={blok.layout}
      items={items}
      id={blok.anchor}
      {...storyblokEditable(blok)}
    />
  );
};

export default ArticleHighlight;
